<template>
    <div v-if="expiredGhostCardMessage" :class="paddingClass">
        <b-notification aria-close-label="Close notification" :type="type">
        <p>
          {{ expiredGhostCardMessage }}
        </p>
      </b-notification>
    </div>
  </template>
  
  <script>
  export default {
    name: "ExpiredGhostCardNotification",
    props: {
      payments: {
        type: Array,
        required: true,
        default: () => [],
      },
      paddingClass: {
        type: String,
        default: "pb-4",
      },
      type: {
        type: String,
        default: "is-warning is-light",
      }
    },
    computed: {
      expiredGhostCardMessage() {
        // Check if there's only one payment with recordType "Corporate Ghost Card" and validExpiration is false
        const singleExpiredGhostCard =
          this.payments.length === 1 &&
          this.payments[0].recordType === "Corporate Ghost Card" &&
          this.payments[0].validExpiration === false;
  
        // Check if there is more than one payment with status "Active" and validExpiration is true
        const activeValidPayments = this.payments.filter(
          (payment) => payment.status === "Active" && payment.validExpiration === true
        );
  
        if (singleExpiredGhostCard && activeValidPayments.length === 0) {
          return "Your travel policy's centralized payment method has expired. Please notify your travel champion to update the expiration date in order to book travel.";
        } 
        return null;
      },
    },
    methods: {
      close() {
        this.$emit("close");
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .is-danger.is-light {
    background-color: #ffccd6;
    color: #7f0019;
  }
  .is-warning.is-light {
    background-color: #fff0cc;
    color: #422e00;
}
  </style>
  